import { ReportsList } from "../components/List/ReportsList";
import { ReportsCreate } from "../components/Create/ReportsCreate";
import { ReportsEdit } from "../components/Edit/ReportsEdit";
import { ReportsView } from "../components/View/ReportsView";
import { SnippetsOutlined } from "@ant-design/icons";
export const REPORTS_LIST = {
    path: "/admin/reports",
    component: ReportsList,
    menu: {
        key: "REPORTS_LIST",
        label: "management.reports.menu.title",
        icon: SnippetsOutlined,
    },
};
export const REPORTS_CREATE = {
    path: "/admin/reports/create",
    component: ReportsCreate,
};
export const REPORTS_EDIT = {
    path: "/admin/reports/:id/edit",
    component: ReportsEdit,
};
export const REPORTS_VIEW = {
    path: "/admin/reports/:id/view",
    component: ReportsView,
};
